<script lang="ts">
	import { toastStore } from '../stores/toastStore';
	import GlassToast from './GlassToast.svelte';
</script>

<div class="fixed top-4 left-1/2 -translate-x-1/2 z-[9999] flex flex-col items-center gap-2 pointer-events-none">
	{#each $toastStore as item (item.id)}
		<GlassToast {item} />
	{/each}
</div>
